/*
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-05-23 09:47:14
 * @FilePath: \frontend\src\api\sys.js
 */
// import { hasValue } from '@/utils/serverUtils';
import { errorMsg } from '@/utils/message';
import { errorNotify } from '@/utils/errorNotification';
import { gatewayPermissionRequest } from '@/utils/serviceContext';
// import { msg } from './const/serverMessage';
// import { sysCfgType } from '@/utils/const';

/**
 * @typedef {object} Result
 * @property {number} status - 実行結果のステータス
 * @property {any}data - 実行結果のデータ
 */

// const sysCfg = {};

/*
export function getNtpServer() {
  return request({
    url: '/sys/getNtpServer',
    method: 'post',
  });
}
*/

export function getSysTime() {
  // return request({
  //   url: '/sys/getTime',
  //   method: 'post',
  // });
}

/*
export function getSysTimeInfo() {
  return request({
    url: '/sys/getTimeInfo',
    method: 'post',
  });
}
*/

/*
export function setSysTime(data) {
  return request({
    url: '/sys/setTime',
    method: 'post',
    data: data,
  });
}
*/

/*
export function setSysTimeZone(data) {
  return request({
    url: '/sys/setTimeZone',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getSysNetwork() {
  return request({
    url: '/sys/getNetwork',
    method: 'post',
  });
}
*/

export function getSysInfo() {
  // return request({
  //   url: '/sys/getSysInfo',
  //   method: 'post',
  // });
}

/*
export function setSysNetwork(data) {
  return request({
    url: '/sys/setNetwork',
    method: 'post',
    data: data,
  });
}
*/

/*
export function sysUpgrade() {
  return request({
    url: '/sys/upgrade',
    method: 'post',
  });
}
*/

/*
export function ntpServerTest(data) {
  return request({
    url: '/sys/ntpServerTest',
    method: 'post',
    data: data,
  });
}
*/

/*
export function setNtpServer(data) {
  return request({
    url: '/sys/setNtpServer',
    method: 'post',
    data: data,
  });
}
*/

/*
export function setNtpOption(data) {
  return request({
    url: '/sys/setNtpOption',
    method: 'post',
    data: data,
  });
}
*/

/*
export function uploadFilePart(data) {
  return request({
    url: '/sys/uploadFilePart',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getFilePartList() {
  return request({
    url: '/sys/getFilePartList',
    method: 'post',
  });
}
*/

/*
export function mergeFile(data) {
  return request({
    url: '/sys/mergeFile',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getSysApWlan() {
  return request({
    url: '/sys/getApWlan',
    method: 'post',
  });
}
*/

/*
export function setSysApWlan(data) {
  return request({
    url: '/sys/setApWlan',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getSysApIp() {
  return request({
    url: '/sys/getApIp',
    method: 'post',
  });
}
*/

/*
export function setSysApIp(data) {
  return request({
    url: '/sys/setApIp',
    method: 'post',
    data: data,
  });
}
*/

/*
export function setSysApOption(data) {
  return request({
    url: '/sys/setApOption',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getStationList() {
  return request({
    url: '/sys/getStationList',
    method: 'post',
  });
}
*/

/*
export function getWListOption() {
  return request({
    url: '/sys/getWListOption',
    method: 'post',
  });
}
*/

/*
export function getWList() {
  return request({
    url: '/sys/getWList',
    method: 'post',
  });
}
*/

/*
export function setWListOption(data) {
  return request({
    url: '/sys/setWListOption',
    method: 'post',
    data: data,
  });
}
*/

/*
export function delWList(data) {
  return request({
    url: '/sys/delWList',
    method: 'post',
    data: data,
  });
}
*/

/*
export function addWList(data) {
  return request({
    url: '/sys/addWList',
    method: 'post',
    data: data,
  });
}
*/

/*
export function connectSubGHzGateway() {
  return request({
    url: '/connectSubGHzGateway',
    method: 'post'
  })
  return new Promise(resolve => resolve({ status: 0 }));
}
*/

/*
export function getTfCardInfo() {
  return request({
    url: '/sys/getTfCardInfo',
    method: 'post',
  });
}
*/

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.gateway - ゲートウェイのID
 * @param {string} data.cfgKey - システムコンフィグのキー
 * @return {Promise<Result>} 実行結果のオブジェクト（data: システムコンフィグ）
 */
export async function getSysCfg(data) {
  let res_cfg = null;
  let res = { status: 0 };
  try {
    res_cfg = await gatewayPermissionRequest({
      url: '/areamasters/rwm/methods/sysconfig',
      method: 'get',
      params: {
        gateway_id: data.gateway,
        cfg_key: data.cfgKey,
      },
    });
    res.data = res_cfg;
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/**
 * @param {Object} data 入力データオブジェクト
 * @param {string} data.gateway - ゲートウェイのID
 * @param {string} data.cfgKey - システムコンフィグのキー
 * @param {string} data.cfgValue - システムコンフィグの値
 * @return {Promise<Result>} 実行結果のオブジェクト（data: システムコンフィグ）
 */
export async function saveSysCfg(data) {
  let res = { status: 0 };
  try {
    await gatewayPermissionRequest({
      url: '/areamasters/rwm/methods/sysconfig',
      method: 'post',
      params: {
        gateway_id: data.gateway,
        cfg_key: data.cfgKey,
      },
      data: {
        cfgValue: data.cfgValue,
      },
    });
  } catch {
    // TODO
    res = {
      status: -2,
      data: [{ cause: errorMsg.e_request_failed_err }],
    };
    errorNotify(res);
  }
  return res;
}

/*
export function deleteSysCfg(data) {
  return request({
    url: '/sysCfg/delete',
    method: 'post',
    data: data,
  });
}
*/

/*
export function isExclusive(data) {
  return request({
    url: '/sys/isExclusive',
    method: 'post',
    data: data,
  });
}
*/

/*
export function setSubGHzUdpMode(data) {
  return request({
    url: '/sys/setSubGHzUdpMode',
    method: 'post',
    data: data,
  });
}
*/

/**
 * @return {Promise<Result>} 実行結果のオブジェクト（data: モード情報）
 */
export function getSubGHzUdpMode() {
  /* 
    mode: 0 => Serial
    mode: 1 => UDP(not implemented)
  */
  return new Promise((resolve) => resolve({ status: 0, data: { mode: 0 } }));
}

/*
export function exportBackup() {
  return request({
    url: '/sys/exportBackup',
    method: 'post',
  });
}
*/

/*
export function exportDeviceList() {
  return request({
    url: '/sys/exportDeviceList',
    method: 'post',
  });
}
*/

/*
export function exportUnitValueCsv() {
  return request({
    url: '/sys/exportUnitValueCsv',
    method: 'post',
  });
}
*/

/*
export function exportSettingFile() {
  return request({
    url: '/sys/exportSettingFile',
    method: 'post',
  });
}
*/

/*
export function reboot() {
  return request({
    url: '/sys/reboot',
    method: 'post',
  });
}
*/

/*
export function setWlanOption(data) {
  return request({
    url: '/sys/setWlanOption',
    method: 'post',
    data: data,
  });
}
*/

/*
export function setWlanStation(data) {
  return request({
    url: '/sys/setWlanStation',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getWlanStation() {
  return request({
    url: '/sys/getWlanStation',
    method: 'post',
  });
}
*/

/*
export function getWlanOption() {
  return request({
    url: '/sys/getWlanOption',
    method: 'post',
  });
}
*/

/*
export function scanWlanList() {
  return request({
    url: '/sys/scanWlanList',
    method: 'post',
  });
}
*/

/*
export function setSubgDstInfo(data) {
  return request({
    url: '/sys/setSubgDstInfo',
    method: 'post',
    data: data,
  });
}
*/

/*
export function getSubgDstInfo() {
  return request({
    url: '/sys/getSubgDstInfo',
    method: 'post',
  });
}
*/

/*
export function removeTfCard() {
  return request({
    url: '/sys/removeTfCard',
    method: 'post',
  });
}
*/

/*
export function downloadLogFile() {
  return request({
    url: '/sys/downloadLogFile',
    method: 'post',
  });
}
*/
